import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { omitBy } from 'lodash'

import styles from './Text.module.scss'

export const TEXT_WEIGHT_OPTIONS = ['normal', 'bold']
export const TEXT_DISPLAY_OPTIONS = ['inline', 'block']
export const TEXT_TRANSFORM_OPTIONS = ['none', 'uppercase', 'lowercase']
export const TEXT_COLOR_OPTIONS = [
  'blue',
  'white',
  'greyBlue',
  'coolGrey',
  'paleGrey',
  'black',
  'cloudyBlue',
  'blueGrey',
]

export const Text = ({
  children,
  dataTestId,
  size = 14,
  lineHeight = 1.29,
  letterSpacing,
  display,
  weight = 'normal',
  color,
  textTransform = 'none',
  className,
  truncate = false,
  onClick,
}) => {
  const style = omitBy(
    {
      textTransform,
      lineHeight,
      fontSize: `${size}px`,
      fontWeight: weight,
      display,
      letterSpacing: letterSpacing && `${letterSpacing}px`,
    },
    item => !item,
  )

  const classList = classNames(
    styles.text,
    {
      [styles.truncate]: truncate,
      [styles.blue]: color === 'blue',
      [styles.white]: color === 'white',
      [styles.greyBlue]: color === 'greyBlue',
      [styles.coolGrey]: color === 'coolGrey',
      [styles.paleGrey]: color === 'paleGrey',
      [styles.black]: color === 'black',
      [styles.cloudyBlue]: color === 'cloudyBlue',
      [styles.blueGrey]: color === 'blueGrey',
    },
    className,
  )

  return (
    <span style={style} className={classList} data-test-id={dataTestId} onClick={onClick}>
      {children}
    </span>
  )
}

Text.propTypes = {
  children: PropTypes.any,
  dataTestId: PropTypes.string,
  size: PropTypes.number,
  letterSpacing: PropTypes.number,
  weight: PropTypes.oneOf(TEXT_WEIGHT_OPTIONS),
  display: PropTypes.oneOf(TEXT_DISPLAY_OPTIONS),
  textTransform: PropTypes.oneOf(TEXT_TRANSFORM_OPTIONS),
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  color: PropTypes.oneOf(TEXT_COLOR_OPTIONS),
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  truncate: PropTypes.bool,
  onClick: PropTypes.func,
}
